import {CREATE_OR_UPDATE_ASSIGNMENT_SESSION} from '../constants'
import {setInStorage} from '../util/storage'

let sessionStorage
try {
  sessionStorage = window.sessionStorage
} catch {
  sessionStorage = null
}

export default (state = {}, action = {}) => {
  switch (action.type) {
    case CREATE_OR_UPDATE_ASSIGNMENT_SESSION:
      setInStorage(sessionStorage, `${action.scope}_token`, action.assignmentSession.token)
      return Object.assign({}, state, {[action.scope]: action.assignmentSession})
    default:
      return state
  }
}
